import { ERCButton } from "components/button";
import React from "react";
import { TiStar } from "react-icons/ti";
import { useNavigate } from "react-router-dom";

const GameCard = ({ goodsTitle, goodsDirection, img, width, height }) => {
  const navigate = useNavigate();
  const style = {
    width: width,
    height: height,
  };
  return (
    <div className="w-full h-[100px] bg-[#F5F5F5] pt-[20px]" style={style}>
      <p className="font-manrope text-[32px] leading-[40px] font-semibold pl-[17px]">
        {goodsTitle}
      </p>
      <div className="flex underline gap-[5px]">
        <p
          className="font-manrope text-[16px] leading-[24px] font-semibold pl-[20px] cursor-pointer"
          onClick={() => {
            window.scrollTo(0, 0);
            navigate("/store/student");
          }}
        >
          {goodsDirection}
        </p>

        <img src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721812943/ERC/arrow-right_jmcncy.svg" />
      </div>

      <img src={img} alt="purchase-items" />
    </div>
  );
};

const TeacherStudentCard = ({
  teacherStudentGoodsTitle,
  shopNow,
  img,
  width,
  height,
}) => {
  const navigate = useNavigate();

  const style = {
    width: width,
    height: height,
  };
  return (
    <div className="w-full bg-[#F5F5F5] pt-[20px]" style={style}>
      <div className="flex md:flex-row flex-col">
        <div className="flex flex-col md:pt-[140px] pt-6">
          <p className="font-manrope text-[32px] leading-[40px] font-semibold pl-[17px]">
            {teacherStudentGoodsTitle}
          </p>
          <div className="flex underline gap-[5px]">
            <p
              className="font-manrope text-[16px] leading-[24px] font-semibold pl-[20px] cursor-pointer"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/store/product");
              }}
            >
              {shopNow}
            </p>
            <img src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721812943/ERC/arrow-right_jmcncy.svg" alt="teacher-store-img"/>
          </div>
        </div>
        <img src={img} alt="shoe" />
      </div>
    </div>
  );
};

const StoreCard = ({
  discount,
  viewDetails,
  title,
  amount,
  slashPrice,
  number,
  img,
  width,
  height,
  onClick,
  imgWidth,
  imgHeight,
}) => {
  const navigate = useNavigate();
  const style = {
    width: width,
    height: height,
  };

  return (
   <div className="w-full px-6 bg-[#F5F5F5] py-4 rounded-md shadow-md">
  {/* Badge Image - Full Width, Fixed Height */}
  <div className="w-[80px] h-auto">
    <img
      className="w-full h-full object-contain"
      src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721819663/ERC/Badge_medium_epulvy.svg"
      alt="Badge"
    />
  </div>

  {/* Discount Tag */}
  <div className="bg-[#00296B] w-fit px-4 py-1 rounded-md text-white text-sm font-medium mt-2">
    {discount}
  </div>

  {/* Product Image - Full Width, Fixed Height */}
  <div className="w-full h-[250px] mt-4">
    <img src={img} alt="Product" className="w-full h-full object-cover rounded-md" />
  </div>

  {/* Button */}
  <div className="flex items-center justify-center py-4">
    <ERCButton
      weight="500"
      g="4px"
      size="16px"
      p="8px"
      color="#FFD600"
      lHeight="28px"
      width="250px"
      height="46px"
      onClick={onClick}
    >
      {viewDetails}
    </ERCButton>
  </div>

  {/* Product Info */}
  <div>
    <p className="font-manrope text-xl font-semibold text-[#00296B] mt-2">{title}</p>

    <div className="flex items-center gap-2 mt-1">
      <p className="text-lg font-semibold text-[#121212]">{amount}</p>
      <p className="text-sm text-[#6C7275] line-through">{slashPrice}</p>
    </div>

    {/* Star Ratings */}
    <div className="flex items-center mt-1">
      {[...Array(4)].map((_, index) => (
        <TiStar key={index} className="text-[#FFDC60]" />
      ))}
      <TiStar className="text-[#8F8F8F]" />
      <p className="text-xs text-[#6C7275] ml-1">{number}</p>
    </div>
  </div>
</div>

  );
};

export { GameCard, TeacherStudentCard, StoreCard };
